<template>
    <div v-if="!loadingPage">
        <validation-observer #default="{ invalid }">

            <div class="d-flex justify-content-between align-items-center">
                <h3 class="text-primary mb-2">
                    اطلاعات مدیر
                </h3>
                <b-button v-if="!managerInformationConfirmed" @click="registerStore" type="submit" variant="primary"
                    :disabled="invalid || loading" class="px-3 mb-2">
                    <span>ذخیره</span>
                </b-button>
                <!-- ویرایش برای زمانی است که اطلاعات مدیر مجموعه نیاز به تغییر دارد. قبل از هر گونه
                ویرایشی، ضروری است که نامه‌ای کتبی با امضای مدیر قبلی تهیه شود که در آن، مشخصات مدیر
                جدید و انتقال پنل به او ذکر شده باشد. هر دو طرف باید این نامه را امضا کنند. علاوه بر
                این، یک قرارداد جدید نیز باید برای مدیر جدید ارسال شود تا امضا کند. شماره قراردادهای
                قبلی و جدید باید در نامه کتبی ذکر شود. -->
                <!-- <b-button v-if="managerInformationConfirmed" @click="changeUserIdentity" type="submit" variant="primary"
                    :disabled="invalid || loading" class="px-3 mb-2">
                    <span>ویرایش</span>
                </b-button> -->
            </div>

            <b-card>

                <b-form class="row auth-login-form" @submit.prevent>
                    <div class="col-12 mb-2">
                        <div v-if="!managerInformationConfirmed" class="text-justify">
                            <h6>- برای فعال شدن حساب، لطفا اطلاعات زیر را تکمیل کنید.</h6>
                            <h6>- شناسه مجموعه برای ساخت URL استفاده شده و در منو نمایش داده نمی‌شود. ( مثال :
                                cafe-demo )
                            </h6>
                        </div>
                        <div v-else>
                            <h5 class="text-success">
                                هویت شما تایید شد
                            </h5>
                            <h6 class="d-flex align-items-center flex-wrap">
                                <span>برای تکمیل اطلاعات مجموعه، وارد صفحه</span>
                                <router-link class="mx-25" to="/basic-settings">تنظیمات مجموعه</router-link>
                                <span>شوید.</span>
                            </h6>
                        </div>
                    </div>

                    <!-- firstName -->
                    <b-form-group label="نام" label-for="firstNameId" class="col-12 col-md-6 col-lg-3">
                        <validation-provider #default="{ errors }" name="نام" rules="required">
                            <b-form-input :disabled="managerInformationConfirmed" dir="rtl" id="firstNameId"
                                v-model="form.firstName" name="firstName"
                                class="text-center font-weight-bolder user-select-none"
                                :state="errors.length > 0 ? false : null" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>

                    <!-- lastName -->
                    <b-form-group label="نام خانوادگی" label-for="lastNameId" class="col-12 col-md-6 col-lg-3">
                        <validation-provider #default="{ errors }" name="نام خانوادگی" rules="required">
                            <b-form-input :disabled="managerInformationConfirmed" dir="rtl" id="lastNameId"
                                v-model="form.lastName" name="lastName"
                                class="text-center font-weight-bolder user-select-none"
                                :state="errors.length > 0 ? false : null" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>

                    <!-- national code -->
                    <b-form-group label="کد ملی" label-for="nationalCodeId" class="col-12 col-md-6 col-lg-3">
                        <validation-provider #default="{ errors }" name="کد ملی" rules="nationalCode|required">
                            <b-form-input :disabled="managerInformationConfirmed" dir="ltr" id="nationalCodeId"
                                v-model="form.nationalCode" class="text-center font-weight-bolder" name="nationalCode"
                                :state="errors.length > 0 ? false : null" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>

                    <!-- phone number -->
                    <b-form-group label="شماره همراه" label-for="phoneNumberId" class="col-12 col-md-6 col-lg-3">
                        <validation-provider #default="{ errors }" name="شماره همراه" rules="phoneNumber|required">
                            <b-form-input :disabled="managerInformationConfirmed" dir="ltr" id="phoneNumberId"
                                v-model="form.phoneNumber" name="phoneNumber" :state="errors.length > 0 ? false : null"
                                class="text-center font-weight-bolder user-select-none" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>

                    <!-- store ID -->
                    <b-form-group v-if="!managerInformationConfirmed" label="شناسه مجموعه" label-for="storeName_EnId"
                        class="col-12 col-md-6 col-lg-3">
                        <validation-provider #default="{ errors }" name="شناسه مجموعه" rules="store_Id|required">
                            <b-form-input dir="ltr" id="storeName_EnId" v-model="form.storeName_En"
                                :state="errors.length > 0 ? false : null" name="storeName_En"
                                class="text-center font-weight-bolder user-select-none" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>

                </b-form>
            </b-card>

        </validation-observer>
        <!--------------------- modal --------------------->
        <b-modal id="confirm-code" title="تایید کد" size="sm" centered :hide-footer="true"
            title-class="font-weight-bolder">
            <div class="p-1">
                <b-card-text class="text-primary-middle font-weight-bolder">کد تایید را وارد کنید</b-card-text>
                <b-card-text class="text-primary-middle mb-2 pb-50">کد تایید برای شماره {{ form.phoneNumber }} پیامک
                    شد</b-card-text>

                <b-form class="auth-login-form" @submit.prevent>
                    <CodeInput v-model="code" :loading="false" :fieldWidth="44" :fieldHeight="44" class="input"
                        dir="ltr" />
                    <div class="text-center my-1">
                        <b-button variant="white" :disabled="!counterEnded" @click.prevent="registerStore"
                            class="btn btn-no-focus font-weight-bolder text-secondary">
                            <div class="text-main" v-if="!startCounter">
                                <feather-icon icon="RotateCcwIcon" />
                                <span class="mx-1">ارسال مجدد</span>
                            </div>
                            <countdown v-if="startCounter" @end="checkCounterEndTime" :time="timerCount">
                                <template slot-scope="props"> {{ props.minutes }}:{{ props.seconds }} مانده تا دریافت
                                    مجدد
                                    کد</template>
                            </countdown>
                        </b-button>
                    </div>

                    <!-- submit buttons -->
                    <b-button type="submit" variant="primary" block @click="confirmAdminIdentity"
                        :disabled="loading || code.length !== 5"
                        class="d-flex align-items-center justify-content-center mt-3">
                        <span>تایید</span>
                        <b-spinner v-if="loading" variant="white" class="ml-50" small></b-spinner>
                    </b-button>
                    <b-button @click.prevent="$bvModal.hide('confirm-code')" type="submit" variant="outline-primary"
                        block class="mt-2">ویرایش
                        شماره</b-button>
                </b-form>
            </div>
        </b-modal>

        <!----------------- Change Password Component ----------------->
        <div v-if="managerInformationConfirmed">
            <ChangePassword :phoneNumber="form.phoneNumber" :hasPassword="hasPassword" />
        </div>
    </div>
</template>

<script>
import { BRow, BCol, BButton, BCard, BCardText, BForm, BFormGroup, BSpinner, BFormInput, BCardBody } from 'bootstrap-vue';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { nationalCode, required, phoneNumber, store_Id } from '@validations';
import { storeRegistrationService, storeService } from '@core/services';
import ChangePassword from '@/@core/components/change-password/index.vue';
import CodeInput from '@core/components/code-verifier';

export default {
    components: {
        BRow,
        BCol,
        BFormGroup,
        BFormInput,
        BCard,
        BCardText,
        BCardBody,
        BButton,
        BForm,
        BSpinner,
        ValidationProvider,
        ValidationObserver,
        CodeInput,
        ChangePassword
    },
    data() {
        return {
            managerInformationConfirmed: false,
            loading: false,
            loadingPage: true,
            startCounter: false,
            counterEnded: false,
            timerCount: 2 * 60 * 1000,
            form: {
                nationalCode: null,
                phoneNumber: '',
                storeName_En: null,
                firstName: null,
                lastName: null,
            },
            nationalCode,
            required,
            phoneNumber,
            store_Id,
            code: '',
            storeId: null,
            hasPassword: null
        };
    },
    methods: {
        checkCounterEndTime() {
            this.counterEnded = true;
            this.startCounter = false;
        },
        registerStore() {
            if (this.managerInformationConfirmed) {
                this.changeUserIdentity()
            }
            else {
                this.loading = true
                storeRegistrationService.registerStore(this.storeId, this.form).then(({ data }) => {
                    if (!data.needVerify) {
                        storeService.getInfo(this.storeId).then(({ data }) => {
                            localStorage.setItem("urlName", data.urlName)
                            this.$axios.get('/Auth/GetUserInfo').then(({ data }) => {
                                localStorage.setItem("userInfo", JSON.stringify(data))
                                this.loading = false
                                location.reload();
                            })
                        })
                    }
                    else {
                        this.loading = false
                        this.$bvModal.show('confirm-code')
                        this.startCounter = true;
                        this.counterEnded = false;
                    }
                })
                    .catch((err) => {
                        this.loading = false
                    })
            }
        },
        confirmAdminIdentity() {
            this.loading = true
            if (this.managerInformationConfirmed) {
                this.$axios.post(`store/auth/${this.storeId}/confirmUserIdentity`, { code: this.code }).then((data) => {
                    this.$axios.get('/Auth/GetUserInfo').then(({ data }) => {
                        localStorage.setItem("userInfo", JSON.stringify(data))
                        this.loading = false
                        location.reload();
                    })
                })
                    .catch((err) => {
                        this.loading = false
                    })
            }
            else {
                storeRegistrationService.confirmAdminIdentity(this.storeId, { code: this.code }).then(({ data }) => {
                    this.$axios.get('/Auth/GetUserInfo').then(({ data }) => {
                        localStorage.setItem("userInfo", JSON.stringify(data))
                        this.loading = false
                        location.reload();
                    })
                })
                    .catch((err) => {
                        this.$bvModal.hide('confirm-code')
                        this.loading = false
                    })
            }
        },
        changeUserIdentity() {
            this.loading = true
            const data = {
                phoneNumber: this.form.phoneNumber,
                firstName: this.form.firstName,
                lastName: this.form.lastName,
                nationalCode: this.form.nationalCode
            }
            this.$axios.post(`store/auth/${this.storeId}/changeUserIdentity`, data).then(({ data }) => {
                if (!data.needVerify) {
                    this.$axios.get('/Auth/GetUserInfo').then(({ data }) => {
                        localStorage.setItem("userInfo", JSON.stringify(data))
                        this.loading = false
                        location.reload();
                    })
                }
                else {
                    this.loading = false
                    this.$bvModal.show('confirm-code')
                    this.startCounter = true;
                    this.counterEnded = false;
                }
            })
                .catch((err) => {
                    this.loading = false
                })
        },
        async getUserInfo() {
            await this.$axios.get('/Auth/GetUserInfo').then(({ data }) => {
                this.form.phoneNumber = data.phoneNumber
                this.form.nationalCode = data.nationalCode
                this.form.lastName = data.lastName
                this.form.firstName = data.firstName
                this.hasPassword = data.hasPassword
                localStorage.setItem("userInfo", JSON.stringify(data))
            })
        },
        getCompletionStatus() {
            storeService.getCompletionStatus(this.storeId).then(({ data }) => {
                if (data.isAdminIdentityVerified) {
                    this.managerInformationConfirmed = true
                }
                this.loadingPage = false;
            })
        },
    },
    mounted() {
        this.storeId = localStorage.getItem("storeId")
        this.getUserInfo();
        this.getCompletionStatus()
    },
};
</script>